export const MEMBER_PRICES = {
  month: 6,
  year: 60,
};

export const PROFILE_PRICES = {
  month: 1.5,
  year: 15,
};

export const COLLABORATOR_PRICES = {
  month: 1.5,
  year: 15,
};

// Plan details

export const PRO = {
  numberOfUsers: 0,
  numberOfProfiles: 1,
  maxProfiles: 10,
  price: {
    month: 7,
    year: 70,
  },
};

export const PRO_PLUS = {
  numberOfUsers: 4,
  numberOfProfiles: 6,
  price: {
    month: 24,
    year: 240,
  },
};

export const ORG_PRO = {
  numberOfUsers: 2,
  numberOfProfiles: 1,
  price: {
    month: 14,
    year: 140,
  },
};

export const ORG_PRO_PLUS = {
  numberOfUsers: 3,
  numberOfProfiles: 1,
  price: {
    month: 29,
    year: 290,
  },
};
